export const common = {
    state: {
        isLogin: true
    },
    reducers: {
        isLogin(state, isLogin) {
            return Object.assign({}, state, {
                isLogin: isLogin,
            });
        }
    }
}

export { template } from './page/jsx/Template';
export { mobile } from './page/mobile/MobileTemplate';



// WEBPACK FOOTER //
// ./src/models.js